import React from 'react'
import { Skeleton, type SkeletonProps, styled } from '@mui/material'

const NoMarginSkeleton = styled(Skeleton)`
    margin: 0;
    padding: 0;
`

interface Props {
    loading: boolean
    SkeletonComponent?: React.ReactNode
    skeletonProps?: SkeletonProps
    children?: React.ReactNode
    alignSkeleton?: AlignSkeleton
}

type AlignSkeleton = 'left' | 'center' | 'right'

let AlignDiv = styled('div')`
    display: inherit;
`

/**  This component is extended by other loader components (LoaderH6) or can be used directly.
 * If used directly, skeletonProps should contain numeric height and width values.
 * */
export const GenericLoader: React.FC<Props> = ({
    loading,
    SkeletonComponent = NoMarginSkeleton,
    skeletonProps,
    children,
    alignSkeleton,
}: Props) => {
    const makeAlign = (align: AlignSkeleton): string => {
        switch (align) {
            case 'left':
                return 'flex-start'
            case 'center':
                return 'center'
            case 'right':
                return 'flex-end'
            default:
                throw new Error('Generic loader received invalid align prop')
        }
    }

    if (alignSkeleton) {
        AlignDiv = styled('div')`
            width: 100%;
            display: flex;
            justify-content: ${makeAlign(alignSkeleton)};
        `
    }

    if (!loading) {
        return <>{children}</>
    }

    return React.isValidElement(SkeletonComponent) ? (
        <AlignDiv>{React.cloneElement(SkeletonComponent, { ...skeletonProps })}</AlignDiv>
    ) : null
}
